import type { MembershipTier } from '@/lib/types/membership';

/**
 * 멤버십 플랜 표 — 가격·크레딧·추가혜택.
 *
 * **여기가 유일한 출처다.** 멤버십 서버(lawkit-api PR #94)는 가입 요약·청구만 내려주고 **플랜 표는
 * 내려주지 않는다** — 요금 안내가 프론트 상수로 산다. 서버가 플랜을 내려주게 되면 이 파일만
 * 그 응답으로 바꾸고, 화면(`MembershipPage`)과 계산(`utils/membership-plans.ts`)은 그대로 둔다.
 *
 * 값은 기획 문서(1차 개선-대시보드 「LawKit 마이페이지」, 2026-09-11)의 것이다:
 * Bronze 50만원 → 60만원 크레딧(+20%), Silver 75만원 → 90만원(+20%), Gold 100만원 → 130만원(+30%).
 * 순서가 곧 「가벼운 것부터」다 — `recommendPlan` 이 앞에서부터 고른다.
 */
export interface MembershipPlan {
  tier: MembershipTier;
  /** 월 요금(원, VAT 별도). */
  monthlyPrice: number;
  /** 매월 지급되는 크레딧(원). */
  monthlyCredit: number;
}

export const MEMBERSHIP_PLANS: readonly MembershipPlan[] = [
  { tier: 'BRONZE', monthlyPrice: 500_000, monthlyCredit: 600_000 },
  { tier: 'SILVER', monthlyPrice: 750_000, monthlyCredit: 900_000 },
  { tier: 'GOLD', monthlyPrice: 1_000_000, monthlyCredit: 1_300_000 },
];

/** 사용 요약·추천이 보는 기간(개월). 기획의 「최근 3개월 기준」. */
export const RECENT_PAYMENT_MONTHS = 3;
